export const closeModal = (type) => (dispatch) =>
  dispatch({
    type: "MODAL_CLOSE",
    modal: { type },
  });

export const openModal = (type, props) => (dispatch) =>
  dispatch({
    type: "MODAL_OPEN",
    modal: { type, props },
  });
